import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './pages/homePage';
import AdminAuth from './pages/AdminAuth';
import AdminDashboard from './pages/AdminDashboard';
import GalleryPage from './pages/GalleryPage';
import EventDetailPage from './pages/EventDetailPage';
import AboutUs from './pages/AboutUs';
import Members from './pages/Members';
import Rules from './pages/Rules';
import EventsPage from './pages/EventsPage';
import PaymentResponse from './pages/PaymentResponse';
import { scrollToTopImmediate } from './utils/scrollToTop';
import './styles/fonts.css';

import Footer from './components/Footer';
import RegistrationFormNew from './pages/RegistrationFormNew';

// Component to handle scroll to top on route changes
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToTopImmediate();
  }, [pathname]);

  return null;
};

const App = () => {
  return (
    <div className="min-h-screen font-primary" style={{backgroundColor: '#F1F2E4'}}>
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <div className="pt-16">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/members" element={<Members />} />
            <Route path="/rules" element={<Rules />} />
            <Route path="/register" element={<RegistrationFormNew />} />
            <Route path="/admin" element={<AdminAuth />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/gallery/event/:eventId" element={<EventDetailPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/upcoming-events" element={<EventsPage />} />
            <Route path="/payment/response" element={<PaymentResponse />} />
            <Route path="/payment/success" element={<PaymentResponse />} />
            <Route path="/payment/error" element={<PaymentResponse />} />

          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </div>
  );
};

export default App;